export const signupSteps = [
    { path: '/signup/select-role', label: 'Role' },
    { path: '/signup/select-sport', label: 'Sport Select' }, 
    { path: '/signup/enter-credentials', label: 'Credentials' }
  ];
  
  export const loginSteps = [
    { path: '/login/select-role', label: 'Role' },
    { path: '/login/enter-credentials', label: 'Credentials' }
  ];